module.exports = require('./lib/htmlToJson');
